import React, { useState } from 'react';
import { SearchBar } from './SearchBar';

export type UncontrolledSearchBarProps = {
  initialValue?: string;
  onClick: (value: string) => void;
  placeholder?: string;
};
const UncontrolledSearchBar = ({ initialValue = '', ...props }: UncontrolledSearchBarProps) => {
  const [value, setValue] = useState(initialValue);
  return <SearchBar {...props} value={value} setValue={setValue} />;
};

export { UncontrolledSearchBar };
